import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const StockSatelliteHeader = ({ title, subtitle, backTo = '/stock', backTestId = 'stock-back-btn' }) => (
  <div className="mb-4 flex items-center gap-3">
    <Link
      to={backTo}
      className="p-2 rounded-xl border border-white/10 bg-[#151820] text-gray-400 hover:text-white transition-colors"
      data-testid={backTestId}
    >
      <ArrowLeft className="w-5 h-5" />
    </Link>
    <div>
      <h2 className="text-lg font-bold text-white uppercase tracking-wide">{title}</h2>
      {subtitle && <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>}
    </div>
  </div>
);

export default StockSatelliteHeader;
